/*
 * @Date: 2023-02-14 09:56:14
 * @LastEditTime: 2023-03-14 19:20:16
 */
import BaseLayout from "@/layout/BaseLayout";

export default [
  {
    path: "/index",
    redirect: "/home",
    name: "index",
    component: BaseLayout,
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/home/index.vue"),
      },
      {
        path: "/enrollForm",
        name: "enrollForm",
        component: () => import("@/views/home/enrollForm.vue"),
      },
      {
        path: "/scoreSearch",
        name: "scoreSearch",
        component: () => import("@/views/home/scoreSearch.vue"),
      },
      {
        path: "/waiting",
        name: "waiting",
        component: () => import("@/views/home/waiting.vue"),
      },
      {
        path: "/design",
        name: "design",
        component: () => import("@/views/examination/design.vue"),
      },
      {
        path: "/composition",
        name: "composition",
        component: () => import("@/views/examination/composition.vue"),
      },
      {
        path: "/caption",
        name: "caption",
        component: () => import("@/views/home/caption.vue"),
      },

      {
        path: "/upload",
        name: "upload",
        component: () => import("@/views/chat/chatUpload.vue"),
      },
      {
        path: "/list",
        name: "list",
        component: () => import("@/views/list/list.vue"),
      },
      {
        path: "/enroll",
        name: "enroll",
        component: () => import("@/views/list/enroll.vue"),
      },
      {
        path: "/yjhkUpload",
        name: "yjhkUpload",
        component: () => import("@/views/list/yjhkUpload.vue"),
      },
    ],
  },
  {
    path: "/create",
    name: "create",
    component: () => import("@/views/chat/index.vue"),
  },
  {
    path: "/examination",
    name: "examination",
    component: () => import("@/views/examination/examination.vue"),
  },
];
